module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.currentQuestion.data.sortCount), function(number) {
    return _c('v-layout', {
      key: number,
      attrs: {
        "row": ""
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.currentQuestion.data.choices,
        "label": ("Mon choix N°" + number),
        "single-line": "",
        "bottom": ""
      },
      on: {
        "change": function($event) {
          _vm.selectChanged(number, $event)
        }
      },
      model: {
        value: (_vm.answers[number]),
        callback: function($$v) {
          _vm.$set(_vm.answers, number, $$v)
        },
        expression: "answers[number]"
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0325fe68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/additional/Order.vue
// module id = 316
// module chunks = 1